import ApiClient from '@afosto/api/ApiClient';

class Batches {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Confirm batch
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Confirm a batch for processing; processing will start. Only possible when batch is accepted
   * @returns {Promise}
   */
  confirmBatch(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches/${id}/confirm`,
      method: 'put',
      ...options,
    });
  }

  /**
   * Create batch
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create a new batch
   * @returns {Promise}
   */
  createBatch(body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete batch
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Delete an unconfirmed batch
   * @returns {Promise}
   */
  deleteBatch(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get batch
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a single batch
   * @returns {Promise}
   */
  getBatch(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get errors
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a list of errors for a batch
   * @returns {Promise}
   */
  getBatchErrors(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches/${id}/errors`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List batches
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.code]
   * @param {Object} options - The additional request options
   * @description Get a list of batches
   * @returns {Promise}
   */
  getBatches(query = {}, options = {}) {
    const params = {
      code: query.code,
    };

    return this.apiClient.request({
      url: `/cnt/batches`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Update batch
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update a batch config or reference
   * @returns {Promise}
   */
  updateBatch(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Validate batch
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Request validation for the batch and the dataset. The dataaset and the batch will be locked. When invalid, lock will be lifted. If batch is valid, is_accepted will become true
   * @returns {Promise}
   */
  validateBatch(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/batches/${id}/validate`,
      method: 'put',
      ...options,
    });
  }
}

export const batches = new Batches();

export default Batches;
